// extracted by mini-css-extract-plugin
export default {"swiper":"OffersCarousel_swiper__P-9iI","swiper-slide":"OffersCarousel_swiper-slide__aROcx"};